import "./App.css";

import { useEffect, useState } from "react";
import { Container, Row, Pagination, PaginationItem, PaginationLink } from "reactstrap";

import useIsMobile from "./hook/useIsMobile";
import bgVideoSrc from "./bg_video.mp4";
import bgImage from "./bg.png";
import tableBgImage from "./table_bg.png";
import rowBgImage from "./row_bg.png";
import loupeImage from "./loupe.png";

const App = () => {
  const [allUsers, setAllUsers] = useState<any>([]);

  const [allFilteredUsers, setAllFilteredUsers] = useState<any>(allUsers);
  const [users, setUsers] = useState<any>(allUsers.slice(0, 10));

  const isMobile = useIsMobile();

  const [paginationConfig, setPaginationConfig] = useState<any>({
    currentPage: 1,
    usersPerPage: 10,
    totalPages: Math.ceil(allUsers.length / 10),
    visiblePages: 5,
  });

  useEffect(() => {
    setPaginationConfig((prev: any) => ({ ...prev, visiblePages: isMobile ? 2 : 5 }));
  }, [isMobile]);

  const filterHandler = (e: any) => {
    const value = e.target.value;

    if (value === "") {
      setAllFilteredUsers(allUsers);
      setPaginationConfig({
        ...paginationConfig,
        totalPages: Math.ceil(allUsers.length / paginationConfig.usersPerPage),
      });
      setUsers(allUsers.slice(0, paginationConfig.usersPerPage));
      return;
    }

    const filteredUsers = allUsers.filter((user: any) => user.winner.toLowerCase().includes(value.toLowerCase()));

    setAllFilteredUsers(filteredUsers);

    setUsers(filteredUsers.slice(0, paginationConfig.usersPerPage));
    setPaginationConfig({
      ...paginationConfig,
      totalPages: Math.ceil(filteredUsers.length / paginationConfig.usersPerPage),
      currentPage: 1,
    });
  };

  const getPaginationRange = () => {
    const { currentPage, totalPages, visiblePages } = paginationConfig;

    const half = Math.floor(visiblePages / 2);
    let start = Math.max(1, currentPage - half);
    let end = Math.min(totalPages, currentPage + half);

    if (currentPage <= half) {
      end = Math.min(totalPages, visiblePages);
    } else if (currentPage + half >= totalPages) {
      start = Math.max(1, totalPages - visiblePages + 1);
    }

    return [...Array(end - start + 1)].map((_, i) => start + i);
  };

  const paginationHandler = (page: number) => {
    if (page < 1 || page > Math.ceil(allFilteredUsers.length / paginationConfig.usersPerPage)) {
      return;
    }

    const indexOfLastUser = page * paginationConfig.usersPerPage;
    const indexOfFirstUser = indexOfLastUser - paginationConfig.usersPerPage;
    setUsers(allFilteredUsers.slice(indexOfFirstUser, indexOfLastUser));
    setPaginationConfig({ ...paginationConfig, currentPage: page });
  };

  const fetchData = async () => {
    try {
      const response = await fetch("https://central-api.soccerbet.rs/api/v1/jp_users");
      const data = await response.json();

      const rawUsers = data?.users ?? [];
      const normalized = Array.isArray(rawUsers)
        ? rawUsers.map((item: any) => ({
            winner: item.name,
            user_id: item.code,
            value:
              item.amount != null
                ? `${Number(item.amount).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })} RSD`
                : "",
          }))
        : [];

      setAllUsers(normalized);
      setUsers(normalized.slice(0, 10));
      setAllFilteredUsers(normalized);
      setPaginationConfig({
        ...paginationConfig,
        totalPages: Math.ceil(normalized.length / paginationConfig.usersPerPage),
      });
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Container>
      <Row>
        <div className="tableSectionWrapper" style={{ backgroundImage: `url(${bgImage})` }}>
          <div className="tableSectionHeader">
            <h2 className="text-white p-3 title tableSectionTitle">DOBITNICI JACKPOTOVA</h2>
            <div className="inputWrapper inputWrapperHeader">
              <input type="text" placeholder="Pretraži korisnike" className="inputSearch focus:outline-none" onChange={filterHandler} />
              <img src={loupeImage} alt="loupe" className="iconLoupe" />
            </div>
          </div>
          <div className="tableVideoBgWrapper">
            <div className="tableBackdrop" style={{ backgroundImage: `url(${tableBgImage})` }}>
              <video className="tableBgVideo" src={bgVideoSrc} autoPlay loop muted playsInline />
              <table className="usersTable" style={{ ["--row-bg" as string]: `url(${rowBgImage})` }}>
                <thead>
                  <tr className="thead">
                    <th>Dobitnici</th>
                    <th>ID Korisnika</th>
                    {/* <th>Datum i Vreme</th>
              <th>Jackpot</th> */}
                    <th>Vrednost</th>
                  </tr>
                </thead>
                <tbody>
                  {users.length &&
                    users.map((user: any, index: number) => (
                      <tr key={index} className="tbodyUsers">
                        <td data-label="Dobitnici">{user.winner}</td>
                        <td data-label="ID Korisnika">{user.user_id}</td>
                        {/* <td data-label="Datum i Vreme">{formatDateTime(user.datetime)}</td>
                  <td data-label="Jackpot">{user.jackpot}</td> */}
                        <td data-label="Vrednost">{user.value}</td>
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>
          </div>
          <Pagination size={isMobile ? "md" : "lg"} className={!isMobile ? "d-flex justify-content-center mt-3 tableSectionPagination" : "d-flex justify-content-center mt-3 tableSectionPagination"}>
            <PaginationItem onClick={() => paginationHandler(1)} disabled={paginationConfig.currentPage === 1} className="paginationItem">
              <PaginationLink first href="#" className="paginationLink" />
            </PaginationItem>
            <PaginationItem
              onClick={() => paginationHandler(paginationConfig.currentPage - 1)}
              disabled={paginationConfig.currentPage === 1}
              className="paginationItem"
            >
              <PaginationLink previous href="#" className="paginationLink" />
            </PaginationItem>

            {getPaginationRange().map((page) => (
              <PaginationItem
                key={page}
                active={page === paginationConfig.currentPage}
                onClick={() => paginationHandler(page)}
                className="paginationItem"
              >
                <PaginationLink href="#" className="paginationLink">
                  {page}
                </PaginationLink>
              </PaginationItem>
            ))}

            <PaginationItem
              onClick={() => paginationHandler(paginationConfig.currentPage + 1)}
              disabled={paginationConfig.currentPage === paginationConfig.totalPages}
              className="paginationItem"
            >
              <PaginationLink next href="#" className="paginationLink" />
            </PaginationItem>
            <PaginationItem
              onClick={() => paginationHandler(paginationConfig.totalPages)}
              disabled={paginationConfig.currentPage === paginationConfig.totalPages}
              className="paginationItem"
            >
              <PaginationLink last href="#" className="paginationLink" />
            </PaginationItem>
          </Pagination>

          <p className={!isMobile ? "text-center bottomText tableSectionBottomText" : "text-center bottomText tableSectionBottomText"}>
            {`${paginationConfig.currentPage * paginationConfig.usersPerPage - paginationConfig.usersPerPage + 1}-${Math.min(
              paginationConfig.currentPage * paginationConfig.usersPerPage,
              allFilteredUsers.length
            )} `}
            od {allFilteredUsers.length} rezultata pretrage
          </p>
        </div>
      </Row>
    </Container>
  );
};

export default App;
